import { useLayoutEffect, useRef, useState } from 'react';
import type { RefObject } from 'react';

/** Focuses the status after Apply finishes. Other status updates leave focus alone. */
export const useWorkbookHeaderFocus = (): {
  menuRef: RefObject<HTMLSpanElement | null>;
  statusRef: RefObject<HTMLSpanElement | null>;
  requestAttachmentFocus: () => void;
  resetAttachmentFocus: () => void;
  focusMenu: () => void;
  focusStatus: () => void;
} => {
  const menuRef = useRef<HTMLSpanElement>(null);
  const statusRef = useRef<HTMLSpanElement>(null);
  const [hasCompletedApply, setHasCompletedApply] = useState(false);

  // Wait for the refreshed status to render before looking for its focus target.
  useLayoutEffect(() => {
    if (hasCompletedApply) {
      const statusTarget = statusRef.current?.querySelector('button') ?? statusRef.current;
      const menuTarget = menuRef.current?.querySelector('button');
      (statusTarget ?? menuTarget)?.focus();
    }
  }, [hasCompletedApply]);

  return {
    menuRef,
    statusRef,
    requestAttachmentFocus: () => setHasCompletedApply(true),
    resetAttachmentFocus: () => setHasCompletedApply(false),
    focusMenu: () => menuRef.current?.querySelector('button')?.focus(),
    focusStatus: () => (statusRef.current?.querySelector('button') ?? statusRef.current)?.focus(),
  };
};
